import React, { useEffect, useState } from 'react';
import { isMobileDevice } from 'common/utilities/utils';
import { useSelector } from 'react-redux';
import getHelp from 'styles/staticAssets/images/getHelp.svg';
import { GetHelpLandingView } from '../Presentation/GetHelpLandingView';

export const GetHelpLandingPage = props => {
  const { onStartOrderClick } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { localized = false } = useSelector(data => data.appStateReducer.userStatus);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  });

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  return (
    <div className='get-help-container-section'>
      <div
        style={{
          backgroundImage: `url(${getHelp})`,
        }}
        className='get-help-header-image'
      >
        <h1 className='get-help-image-text'>{props.contentData.bannerTitle}</h1>
      </div>
      <div className='get-help-offers-container'>
        <GetHelpLandingView
          onStartOrderClick={onStartOrderClick}
          contentData={props.contentData}
          history={props.history}
          isLocalized={localized}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};
